module.exports = __webpack_public_path__ + "img/project-18.dc9cd3a0.png";